enum AccountType {
  premium = 'premium',
  customer = 'customer',          // stand business
  freeMember = 'free-member',
  basicMember = 'basic-member',   // stand free
  all = 'all'
}

enum AccountStatus {
  active = 'active',
  inactive = 'inactive',
  suspended = 'suspended',
  customerFree = 'customerFree',
  ghost = 'ghost', //azienda raggiungibile da google ma non dal sito
  obsolete = 'obsolete', //azienda free che sarebbe da rimuovere, ma porta visite per cui per ora resta su
  deleted = 'deleted',
  all = 'all',
}

enum OrderType {
  lastin = 'lastin',
  firstin = 'firstin'
}

enum SponsorLevelEnum {
  none = 'none',
  regular = 'regular',
  main = 'main',
  top = 'top'
}

export { AccountType, AccountStatus, OrderType, SponsorLevelEnum };
